import React, { useEffect } from 'react';
import { createRoot } from "react-dom/client"; // For React 18
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import "./styles/styles.scss";
import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import { ThemeContextProvider } from "./contexts/themeContext";
import { AuthContextProvider } from "./contexts/authContext";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import "./i18n";
import { setupInterceptors } from '../src/App/axiosInstance'; // Adjust the import path as needed

// Wrapper component to use useNavigate in the root file
const AppWrapper = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setupInterceptors(navigate); // Pass navigate to the interceptor setup
  }, [navigate]);

  return <App />;
};

const container = document.getElementById("root");

const children = (
  <Provider store={store}>
    <AuthContextProvider>
      <ThemeContextProvider>
        <Router>
          <React.StrictMode>
            <AppWrapper /> {/* Use the wrapper component here */}
          </React.StrictMode>
        </Router>
      </ThemeContextProvider>
    </AuthContextProvider>
  </Provider>
);

createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
